export default {"src":"/_next/static/media/bkcosmetic_black.8bef331d.svg","height":74,"width":283,"blurWidth":0,"blurHeight":0};